import { Box, Theme } from '@mui/material';
import React from 'react';

const sxStyle = (theme: Theme) => ({
  position: 'relative',
  top: '18%', // change to 17 if including the word scanner
  '.ocrloader p::before': {
    content: "''",
    display: 'inline-block',
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    background: `${theme.palette.grey[400]}`,
    position: 'relative',
    right: '4px',
  },

  '.ocrloader p': {
    color: `${theme.palette.grey[400]}`,
    position: 'absolute',
    bottom: '-30px',
    left: '38%',
    fontSize: '16px',
    fontWeight: '600',
    animation: 'blinker 3s linear infinite',
    fontFamily: 'sans-serif',
    textTransform: 'uppercase',
  },
  '.ocrloader': {
    width: '360px',
    height: '225px',
    position: 'relative',
    left: '50%',
    WebkitTransform: 'translateX(-50%)',
    transform: 'translateX(-50%)',
    top: '40%',
    backfaceVisibility: 'hidden',
  },
  '.ocrloader span': {
    position: 'absolute',
    left: '35px',
    top: '20px',
    width: '85%',
    height: '5px',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: `${theme.palette.grey[400]}`,
    boxShadow: `0 0 10px 1px ${theme.palette.grey[400]} 0 0 1px 1px ${theme.palette.grey[400]}`,
    zIndex: '1',
    transform: 'translateY(95px)',
    animation: 'move 3s cubic-bezier(0.15, 0.54, 0.76, 0.74)',
    animationIterationCount: 'infinite',
    opacity: '.2',
  },
  '.ocrloader:before': {
    borderColor: `${theme.palette.grey[400]}`,
    content: '""',
    position: 'absolute',
    width: '45px',
    height: '46px',
    borderStyle: 'solid',
    borderWidth: ' 0px',
    opacity: '.5',
  },
  '.ocrloader:after': {
    borderColor: `${theme.palette.grey[400]}`,
    content: '""',
    position: 'absolute',
    width: '45px',
    height: '46px',
    borderStyle: 'solid',
    borderWidth: ' 0px',
    opacity: '.5',
  },
  '.ocrloader em:after': {
    borderColor: `${theme.palette.grey[400]}`,
    content: '""',
    position: 'absolute',
    width: '45px',
    height: '46px',
    borderStyle: 'solid',
    borderWidth: ' 0px',
    opacity: '.5',
  },
  '.ocrloader em:before': {
    borderColor: `${theme.palette.grey[400]}`,
    content: '""',
    position: 'absolute',
    width: '45px',
    height: '46px',
    borderStyle: 'solid',
    borderWidth: ' 0px',
    opacity: '.5',
  },
  '.ocrloader::before': {
    left: '0',
    top: '0',
    borderLeftWidth: '5px',
    borderTopWidth: '5px',
    borderRadius: '5px 0 0 0',
  },
  '.ocrloader::after': {
    right: '0',
    top: '0',
    borderRightWidth: '5px',
    borderTopWidth: '5px',
    borderRadius: '0 5px 0 0',
  },
  '.ocrloader em::after': {
    right: '0',
    bottom: '0',
    borderRightWidth: '5px',
    borderBottomWidth: '5px',
    borderRadius: '0 0 5px 0',
  },
  '.ocrloader em::before': {
    left: '0',
    bottom: '0',
    borderLeftWidth: '5px',
    borderBottomWidth: '5px',
    borderRadius: '0 0 0 5px',
  },
  '@keyframes move': {
    ' 0%, 100%': {
      transform: 'translateY(180px)',
    },
    '50%': {
      transform: ' translateY(0%)',
    },
    '75%': {
      transform: 'translateY(180px)',
    },
  },

  '@keyframes blinker': {
    '50%': { opacity: 0 },
  },
});

const QRScanner = () => (
  <Box sx={sxStyle}>
    <Box className="ocrloader">
      {/* <p>Scanning</p> */}
      <em />
      <span />
    </Box>
  </Box>
);

export default QRScanner;
